<template>
  <div class="upper-login-page">
    <canvas id="canvas"></canvas>

    <div style="flex: 1;">
      <div class="web-name">
        <span>数智园区上层管理平台</span>
      </div>
      <div class="login-banner">
        <!--<div class="login-banner-img"></div>-->

        <div class="login-banner-main">
          <!--<div class="login-banner-main-left">-->
          <!--</div>-->
          <div class="demo-input-suffix-box">
            <div class="changeBtn">
              <div class="changeBtnMask"></div>
              <!--<i class="iconfont el-icon-damai-yuanqu1" @click="changeLoginPage" v-if="loginByWx"></i>-->
              <!--<i class="iconfont el-icon-damai-shujulaiyuan" @click="changeLoginPage" v-if="!loginByWx"></i>-->
            </div>
            <!--<wx-login v-if="loginByWx" :appid="wxConfig.appid" :scope="wxConfig.scope" :redirect_uri="wxConfig.redirect_uri" :theme="wxConfig.theme" class="wx-login-box" />-->
            <ul class="demo-input-suffix" v-if="loginByWx">
              <li>上级用户登录</li>
              <li id="company" style="margin-bottom: 5px;">
                <el-input placeholder="集团名称" prefix-icon="el-icon-damai-yuanqu" v-model="yqCode" size="mini" />
              </li>
              <li id="user2" style="margin-bottom: 5px;">
                <el-input placeholder="用户名" prefix-icon="el-icon-damai-yonghu" v-model="superiorPlatformName" size="mini" />
              </li>

              <li id="password2" style="margin-bottom: 5px;">
                <el-input placeholder="密码" prefix-icon="el-icon-damai-weibaoxitongshangchuanlogo" v-model="superiorPlatformPassword" type="password" size="mini" @keyup.enter.native="superiorPlatformLogin" />
              </li>
              <!--<li id="pswforget2" >-->
              <!--<span @click="TopswForget">忘记密码？</span>-->
              <!--</li>-->
              <li id="youcode2" style="margin-bottom: 5px;">
                <el-input placeholder="验证码" prefix-icon="el-icon-damai-yanzhengma" v-model="identityCode" :maxlength=4 class="code" size="mini" @keyup.13.native="superiorPlatformLogin" />
                <img :src="codeImg" alt="验证码" class="codeImg" @click="getIdentityCode">
              </li>
              <li id="prompt2">
                <b v-html="superiorPlatformPromotPro"></b>
              </li>

              <li id="loginBtn2" style="margin-top: 20px;">
                <a @click="superiorPlatformLogin">登录</a>
              </li>
            </ul>

            <ul class="demo-input-suffix" v-if="!loginByWx">
              <li>小区登录</li>
              <li id="company">
                <el-input placeholder="小区名称" prefix-icon="el-icon-damai-yuanqu" v-model="yqCode" size="mini" />
              </li>
              <li id="user">
                <el-input placeholder="用户名" prefix-icon="el-icon-damai-yonghu" v-model="name" size="mini" />
              </li>

              <li id="password">
                <el-input placeholder="密码" prefix-icon="el-icon-damai-weibaoxitongshangchuanlogo" v-model="password" type="password" size="mini" @keyup.enter.native="login" />
              </li>
              <li id="pswforget">
                <span @click="TopswForget">忘记密码？</span>
              </li>
              <li id="youcode">
                <el-input placeholder="验证码" prefix-icon="el-icon-damai-yanzhengma" v-model="identityCode" :maxlength=4 class="code" size="mini" @keyup.13.native="login" />
                <img :src="codeImg" alt="验证码" class="codeImg" @click="getIdentityCode">
              </li>
              <li id="prompt">
                <b v-html="promotPro"></b>
              </li>

              <li id="loginBtn">
                <a @click="login">登录</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <footer class="login_footer">
      <span style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">杭州大麦物联科技有限公司提供技术支持</span>
      <span style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</span>
    </footer>
  </div>

</template>

<script>
  /* eslint-disable */
  import md5 from 'js-md5'
  import bus from '../../utils/bus'
  import {pattern} from '../../utils/regular'
  import {errorHandler} from '../../utils/errorHandler'
  import {errorMessage} from '../../utils/errorCode'
  import {api} from '../api/Summary'

  export default {
    name: 'upper-login',
    components: {},
    data () {
      return {
        loginByWx: true,

        yqCode: '',
        name: '',
        password: '',
        identityCode : '',
        promotPro: '',
        codeImg: '',
        randomStr: '',

        superiorPlatformName: '',
        superiorPlatformPassword: '',
        superiorPlatformPromotPro: '',
      }
    },
    created: function () {
      this.getIdentityCode()
    },
    mounted () {
      const that = this
      window.onresize = () => {
        return (() => {
          this.addBg()
        })()
      }
      this.addBg()
    },
    methods: {
      changeLoginPage () {
        this.superiorPlatformName = ''
        this.superiorPlatformPassword = ''
        this.name = ''
        this.password = ''
        this.identityCode = ''
        this.loginByWx = !this.loginByWx
        this.getIdentityCode()
      },
      TopswForget: function () {
        this.$router.push({
          name: 'resetPassword'
        })
      },
      toHomepage () {
        window.sessionStorage.setItem('navTop', 'homepage')
        this.$router.push({
          name: 'homepage'
        })
      },
      toSummaryPage () {
        this.$router.push({
          name: 'summary-page'
        })
      },

      getIdentityCode () {
        let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
        let pwd = ''
        for (let i = 0; i < 4; i++) {
          let id = Math.ceil(Math.random()*35)
          pwd += chars[id]
        }
        this.randomStr = pwd
        this.$axios.get(`${api.upperGetIdentityCode}/${this.randomStr}`, {})
          .then(res => {
            this.codeImg = res.data.data
          })
          .catch(errorHandler('获取验证码失败'))
      },

      // 上级平台登录
      superiorPlatformLogin () {
        if (!this.yqCode) {
          this.superiorPlatformPromotPro = '<b>请输入集团名称</b>'
          return false
        } else {
          this.superiorPlatformPromotPro = ''
        }
        bus.global.upperData.groupAppCode = this.yqCode
        window.sessionStorage.setItem('groupAppCode', this.yqCode)
        const atn = pattern.accountName
        const psd = pattern.password
        if (!this.superiorPlatformName) {
          this.superiorPlatformPromotPro = '<b>请输入用户名</b>'
          return false
        }else if (!atn.test(this.superiorPlatformName)) {
          this.superiorPlatformPromotPro = '<b>请输入正确的用户名格式</b>'
          return false
        }else {
          this.superiorPlatformPromotPro = ''
        }
        if (!this.superiorPlatformPassword) {
          this.superiorPlatformPromotPro = '<b>请输入密码</b>'
          return false
        }else if (!psd.test(this.superiorPlatformPassword)) {
          this.superiorPlatformPromotPro = '<b>请输入正确的密码格式</b>'
          return false
        } else {
          this.superiorPlatformPromotPro = ''
        }
        if (!this.identityCode) {
          this.superiorPlatformPromotPro = '<b>请输入验证码</b>'
          return false
        } else {
          this.superiorPlatformPromotPro = ''
        }
        this.superiorPlatformPromotPro = ''
        let name = this.superiorPlatformName.toLowerCase()
        let pw = this.superiorPlatformPassword + name
        let once = md5(pw) + name
        let pwd
        for (let i = 0; i < 9; i++) {
          pwd = md5(once)
          once = pwd + name
        }

        this.$axios.post(api.upperLogin, {
          name: name,
          password: pwd,
          identityCode: this.identityCode,
          randomStr: this.randomStr
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              console.log(data)
              // if (res.data.data.buildingCode) {
              //   let buildingCode = res.data.data.buildingCode.join(',')
              //   window.sessionStorage.setItem('accountHasBuildingCode', buildingCode)
              //   bus.global.accountHasBuildingCode = buildingCode
              // }
              let yqAppCodeListStr = JSON.stringify(res.data.data.yqAppCodeList)
              window.sessionStorage.setItem('upperYqAppCodeList', yqAppCodeListStr)
              window.sessionStorage.setItem('upperToken', data.token)
              window.sessionStorage.setItem('upperAccountName', data.name)
              window.sessionStorage.setItem('upperAccountCode', data.code)
              bus.global.upperData.token = data.token
              bus.global.upperData.accountName = data.name
              bus.global.upperData.accountCode = data.code
              bus.global.upperData.yqAppCodeList = data.yqAppCodeList
              // window.sessionStorage.setItem('accountCode', res.data.data.code)

              // window.sessionStorage.setItem('accountPersonCode', data.personCode)
              // window.sessionStorage.setItem('accountPersonName', data.personName)

              // window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
              // window.sessionStorage.setItem('frontPermissionCodes', res.data.data.frontPermissionCodes)

              // bus.global.accountCode = res.data.data.code
              // bus.global.accountName = res.data.data.name
              // bus.global.personCode = data.personCode
              // bus.global.personName = data.personName

              // bus.global.permissionCodes = res.data.data.permissionCodes
              // bus.global.frontPermissionCodes = res.data.data.frontPermissionCodes

              this.toSummaryPage()
            }
          })
          .catch(e => {
            this.$layer.toast({
              icon: 'icon-check',
              content: errorMessage(+e.response.data.data),
              time: 1000
            })
            let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
            let pwd = ''
            for (let i = 0; i < 4; i++) {
              let id = Math.ceil(Math.random()*35)
              pwd += chars[id]
            }
            this.randomStr = pwd
            this.$axios.get(`${api.upperGetIdentityCode}/${this.randomStr}`, {})
              .then(res => {
                this.codeImg = res.data.data
              })
              .catch(errorHandler('获取验证码失败'))
          })
      },

      addBg () {
        var canvas = document.getElementById('canvas'),
          ctx = canvas.getContext('2d'),
          w = canvas.width = window.innerWidth,
          h = canvas.height = window.innerHeight,

          hue = 217,
          stars = [],
          count = 0,
          maxStars = 2500;//星星数量

        var canvas2 = document.createElement('canvas'),
          ctx2 = canvas2.getContext('2d');
        canvas2.width = 100;
        canvas2.height = 100;
        var half = canvas2.width / 2,
          gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half);
        gradient2.addColorStop(0.025, '#CCC');
        gradient2.addColorStop(0.1, 'hsl(' + hue + ', 61%, 33%)');
        gradient2.addColorStop(0.25, 'hsl(' + hue + ', 64%, 6%)');
        gradient2.addColorStop(1, 'transparent');

        ctx2.fillStyle = gradient2;
        ctx2.beginPath();
        ctx2.arc(half, half, half, 0, Math.PI * 2);
        ctx2.fill();

// End cache

        function random(min, max) {
          if (arguments.length < 2) {
            max = min;
            min = 0;
          }

          if (min > max) {
            var hold = max;
            max = min;
            min = hold;
          }

          return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        function maxOrbit(x, y) {
          var max = Math.max(x, y),
            diameter = Math.round(Math.sqrt(max * max + max * max));
          return diameter / 2;
          //星星移动范围，值越大范围越小，
        }

        var Star = function() {

          this.orbitRadius = random(maxOrbit(w, h));
          this.radius = random(60, this.orbitRadius) / 18;
          //星星大小
          this.orbitX = w / 2;
          this.orbitY = h / 2;
          this.timePassed = random(0, maxStars);
          this.speed = random(this.orbitRadius) / 500000;
          //星星移动速度
          this.alpha = random(2, 10) / 10;

          count++;
          stars[count] = this;
        }

        Star.prototype.draw = function() {
          var x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
            y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
            twinkle = random(10);

          if (twinkle === 1 && this.alpha > 0) {
            this.alpha -= 0.05;
          } else if (twinkle === 2 && this.alpha < 1) {
            this.alpha += 0.05;
          }

          ctx.globalAlpha = this.alpha;
          ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius);
          this.timePassed += this.speed;
        }

        for (var i = 0; i < maxStars; i++) {
          new Star();
        }

        function animation() {
          ctx.globalCompositeOperation = 'source-over';
          ctx.globalAlpha = 0.5; //尾巴
          ctx.fillStyle = 'hsla(' + hue + ', 64%, 6%, 2)';
          ctx.fillRect(0, 0, w, h)

          ctx.globalCompositeOperation = 'lighter';
          for (var i = 1, l = stars.length; i < l; i++) {
            stars[i].draw();
          };

          window.requestAnimationFrame(animation);
        }

        animation();
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .head img {
    width: 250px;
    height: 44px;
    margin: 15px 10px 15px 30px;
  }

  .head b {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #000000;
  }
  .head span {
    font-size: 24px;
    font-family: STHeiti;
    font-weight: 600;
    color: #000000;
    line-height: 30px;
    vertical-align: middle;
    display: inline-block;
    padding: 0 10px;
  }
  .centen {
    width: 100%;
    height: 90%;
    background-color: #EFF1F5;
    position: relative;
  }


  footer {
    width: 100%;
    font-size: 13px;
    text-align: center;
    color: #999999;
    background-color: #F0F3F7;
    height: 50px;
    line-height: 35px;
  }

  a:hover {
    cursor: pointer;
  }

  .codeImg {
    display: inline-block;
    width: 100px;
    height: 28px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .codeImg:hover {
    cursor: pointer;
  }

  #prompt, #prompt2 {
    line-height: 16px;
    padding: 0;
    margin: 0;
  }

  #prompt b, #prompt2 b {
    display: block;
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 8px;
    margin-bottom: -5px;
  }

  #pswforget, #pswforget2 {
    margin: 0;
    padding: 0 33px;
    display: flex;
    justify-content: flex-end;
  }

  #pswforget span, #pswforget2 span {
    margin: -5px;
    display: inline-block;
    color: #a6a6a6;
  }

  #pswforget span:hover, #pswforget2 span:hover {
    color: #00A0E6;
    cursor: pointer;
  }

  #youcode, #youcode2 {
    margin: 0;
    display: flex;
    justify-content: space-between;
  }

</style>

<style lang="less">
  .upper-login-page {
    height: 100vh;
    min-height: 685px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: relative;
    #canvas {
      min-height: 685px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }
    .web-name {
      font-size: 36px;
      line-height: 80px;
      text-align: left;
      padding: 0 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2DC4BB;
      .logoImg {
        width: 45px;
        height: 45px;
        margin-right: 6px;
      }
    }
    .login-banner {
      margin-top: 120px;
      height: 360px;
      position: relative;
      .login-banner-img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 360px;
        /*background-image: url('../assets/login.png');*/
        background-position: center center;
      }
      .login-banner-main {
        width: 80%;
        height: 360px;
        margin: 0 auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .login-banner-main-left{
          width:6.2rem ;
          height: 5.8rem;
          /*border: 1px solid red;*/
          /*background: url("../assets/d.png") no-repeat;*/
          background-size: 100% 100%;
          padding: 0.4rem 0;
          box-sizing: border-box;
          margin: 0 4%;
          float: left;
          -webkit-transform: rotate(360deg);
          animation: rotation 15s linear infinite;
          -moz-animation: rotation 15s linear infinite;
          -webkit-animation: rotation 15s linear infinite;
          -o-animation: rotation 15s linear infinite;
        }
        @-webkit-keyframes rotation {
          from {
            -webkit-transform: rotate(0deg);
          }
          to {
            -webkit-transform: rotate(360deg);
          }
        }
        .banner-tip1 {
          color: #ffffff;
          font-size: 28px;
          text-align: left;
        }
        .banner-tip2 {
          margin-top: 10px;
          color: #ffffff;
          font-size: 18px;
          text-align: left;
        }
        .demo-input-suffix-box {
          width: 370px;
          height: 310px;
          /*position: absolute;*/
          /*top: 30px;*/
          /*right: 0;*/
          background: white;
          border: 1px solid #E6E6E6;
          border-radius: 5px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          .changeBtn {
            position: absolute;
            right: 0;
            top: 0;
            overflow: hidden;
            .changeBtnMask {
              position: absolute;
              left: 0;
              top: 0;
              width: 58px;
              height: 58px;
              background-color: #ffffff;
              transform:rotate(45deg) translate(-10px, 26px);
              -ms-transform:rotate(45deg) translate(-10px, 26px);
              -moz-transform:rotate(45deg) translate(-10px, 26px);
              -webkit-transform:rotate(45deg) translate(-10px, 26px);
              -o-transform:rotate(45deg) translate(-10px, 26px);
            }
          }
          .el-icon-damai-yuanqu1 {
            cursor: pointer;
            font-size: 42px;
            color: #00a0e6;
          }
          .el-icon-damai-shujulaiyuan {
            cursor: pointer;
            font-size: 42px;
            color: #00a0e6;
          }
        }
        .demo-input-suffix {
          width: 370px;
          height: 310px;
          /*position: absolute;*/
          /*top: 30px;*/
          /*right: 0;*/
          background: white;
          border: 1px solid #E6E6E6;
          border-radius: 5px;
        }

        .demo-input-suffix li {
          padding: 5px 33px;
        }

        .demo-input-suffix li:first-child {
          text-align: center;
          font-size: 20px;
          line-height: 30px;
          color: #434343;
          /*border-bottom: 1px solid #E6E6E6;*/
        }

        .demo-input-suffix li:first-child {
          margin-bottom: 8px;
        }

        .wx-login-box {
          width: 300px;
          height: 260px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          iframe {
            transform:scale(0.7, 0.7);
            -ms-transform:scale(0.7, 0.7);
            -moz-transform:scale(0.7, 0.7);
            -webkit-transform:scale(0.7, 0.7);
            -o-transform:scale(0.7, 0.7);
          }
        }

        #loginBtn a, #loginBtn2 a {
          display: block;
          color: white;
          background: #009FE5;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          border-radius: 15px;
        }

        .code {
          width: 180px;
        }
      }
    }
    .login-introduce {
      width: 1200px;
      height: 800px;
      margin: 20px auto 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .login_footer {
      background: transparent;
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/UpperLogin.vue